import { Icon, Chip, ListSearch, palette } from '@yuno/design-system-web'
import { Organization } from '@yuno/types'
import { useEffect, useState } from 'react'
import { useOrganization } from '../../hooks/use-organization'
import { DialogTexts } from '../../utils/constants'
import { Item, storage } from '../../yuno-dashboard-container-mfe'
import { OpenSnackbar } from '../layout/hooks/snackbar/snackbar.hook'

interface IProps {
  organizationName?: string
  options: Organization.Organization[]
  organization: Organization.Organization
  error: Organization.Organization
  accounts: Organization.Account[]
  onOpenSnackbar: OpenSnackbar
  success: boolean
  setPrincipal: (value: React.SetStateAction<boolean>) => void
}

const resetInsightsFilters = () => {
  localStorage.removeItem('account')
  localStorage.removeItem('insightsFilters')
}

const resetPaymentsFilters = () => {
  localStorage.setItem('paymentsSearchParams', 'FORBIDDEN_SAVE')
  localStorage.setItem('transactionsSearchParams', 'FORBIDDEN_SAVE')
}

export const OrganizationsList = ({
  options,
  organization,
  error,
  accounts,
  onOpenSnackbar,
  success,
  setPrincipal,
}: IProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [optionsFiltered, setOptions] =
    useState<Organization.Organization[]>(options)
  const [organizationName, setOrganizationName] = useState('')
  const [selected, setSelected] = useState(0)
  const [reload, setReload] = useState(false)
  const open = Boolean(anchorEl)
  const organizationCodeStaff = useOrganization(options)
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
    setReload(true)
  }
  const handleClose = (item) => {
    setAnchorEl(null)
    setSelectedItem(item)
  }
  const handleChange = (e) => {
    const optionsFiltered = options.filter((option) =>
      option.name.toLowerCase().includes(e.target.value.toLowerCase()),
    )
    setOptions(optionsFiltered)
  }
  const handleClickItem = (item) => {
    setSelectedItem(item)
    setOrganizationName(item.name)
    storage.setItem('x-organization-code', item.code)
    storage.removeItem('isTesting')
    handleClose(item)
    resetInsightsFilters()
    resetPaymentsFilters()
  }

  const setSelectedItem = (item) => {
    const tempOptions = Object.assign([], options)
    const currentSelected = tempOptions.find((option) => option.selected)
    const currentSelectedIndex = tempOptions.indexOf(currentSelected)
    tempOptions[currentSelectedIndex] = {
      ...tempOptions[currentSelectedIndex],
      selected: false,
    }
    const itemSelected = tempOptions.find((option) => option.code === item.code)
    const organizationIndex = tempOptions.indexOf(itemSelected)
    tempOptions[organizationIndex] = {
      ...options[organizationIndex],
      selected: true,
    }
    setOptions(tempOptions)
  }
  useEffect(() => {
    if ((!!organizationCodeStaff && error) || accounts?.length === 0) {
      onOpenSnackbar(
        DialogTexts.ERROR_CHANGE_ORGANIZATION,
        'error',
        'Info',
        { vertical: 'bottom', horizontal: 'center' },
        '360px',
      )
      setPrincipalOrganization()
    }
  }, [error, accounts, organizationCodeStaff])

  const setOrganizationCache = (storageOrganization) => {
    if (storageOrganization) {
      const storageOrg = optionsFiltered.find(
        (option) => option.code === storageOrganization,
      )
      const storageOrgIndex = optionsFiltered.indexOf(storageOrg)
      const tempOptions = Object.assign([], { ...options })
      tempOptions[storageOrgIndex] = {
        ...options[storageOrgIndex],
        selected: true,
      }
      setSelected(storageOrgIndex)
      setOrganizationName(storageOrg.name)
      setOptions(tempOptions)
      setSelected(storageOrgIndex)
      storageOrganization === organization?.code
        ? setPrincipal(true)
        : setPrincipal(false)
    }
  }
  const setPrincipalOrganization = () => {
    const principalOrganization = optionsFiltered.find(
      (option) => option.code === organization?.code,
    )
    const principalOrganizationIndex = optionsFiltered.indexOf(
      principalOrganization,
    )
    const tempOptions = Object.assign([], { ...options })
    tempOptions[principalOrganizationIndex] = {
      ...options[principalOrganizationIndex],
      selected: true,
    }
    setOptions(tempOptions)
    setSelected(principalOrganizationIndex)
    setOrganizationName(principalOrganization.name)
    storage.setItem(Item.ORGANIZATION, principalOrganization.code)
    setPrincipal(true)
  }

  useEffect(() => {
    if (reload && success && accounts?.length !== 0) {
      window.location.href = '/'
    }
  }, [accounts])

  useEffect(() => {
    const storageOrganization = storage.getItem(Item.ORGANIZATION)
    storageOrganization
      ? setOrganizationCache(storageOrganization)
      : setPrincipalOrganization()
  }, [])

  return (
    <div>
      <Chip
        onClick={handleClick}
        icon={<Icon size="18" name="UserSwitch" />}
        deleteIcon={<Icon size="12" name="CaretDown" color={palette.grey[5]} />}
        onDelete={() => ({})}
        label={organizationName}
      />
      <ListSearch
        handleClickItem={handleClickItem}
        selected={selected}
        open={open}
        handleClose={handleClose}
        handleChange={handleChange}
        anchorEl={anchorEl}
        options={optionsFiltered}
        transition={0}
        length={15}
      />
    </div>
  )
}
